import { gql } from '@apollo/client';
export const LOCAL_PREDICTED_PRICES = gql`
  query localPredictedPrices {
    predictedPrices @client
  }
`;
